export const GET_ORDER_STATUS_LIST = "GET_ORDER_STATUS_LIST";
export const GET_ORDER_KEYWORD_LIST = "GET_ORDER_KEYWORD_LIST";

export const ORDER_LIST_ACTION = "ORDER_LIST_ACTION";
export const ORDER_WRITE_ACTION = "ORDER_WRITE_ACTION";
